export const BREAKPOINTS = {
  MOBILE: 991,
};
